import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Avatar, Divider, Fab, IconButton, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import List from '@mui/material/List';

import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { getAllItemsSetting, deleteItems } from '../../../../redux/slice/Settings/Items/getAllItemsSettingSlices';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import Progress from '../../../Components/Progress';
import APIErorr from '../../../Components/APIErorr';
import EditIcon from '@mui/icons-material/Edit';
import i18n from '../../../../i18n';
import SquareIcon from '@mui/icons-material/Square';
import { getAllCategorySetting, getAllCategorySettingAndItems, reset } from '../../../../redux/slice/Settings/Category/getAllCategorySettingSlices';
import AddIcon from '@mui/icons-material/Add';
import { getHexColor } from '../../../hepler';
import AddEditItems from './AddEditItems';
import { deleteItemSetting, reset as RestdeleteItemSetting } from '../../../../redux/slice/Settings/Items/deleteItemSettingSlices';
import { t } from 'i18next';
import AlertsDialog from '../../../Components/AlertsDialog';



const getAvatar = (value, isCategory) => {


  const dir = i18n.dir()

  if (value.color === 0) {
    return <Avatar alt={value.name} src={`data:image/jpeg;base64,${value.image}`} sx={{ width: isCategory ? 25 : 50, height: isCategory ? 25 : 50 }} />

  }


  if (value.color !== null) {



    return <Avatar alt={value.name} sx={{ width: isCategory ? 25 : 50, height: isCategory ? 25 : 50, bgcolor: getHexColor(value.color), float: dir === "rtl" ? "right" : "left", marginLeft: 1, marginRight: 1 }} > </Avatar>


  }

  return <Avatar alt={value.name} sx={{ width: isCategory ? 25 : 50, height: isCategory ? 25 : 50, bgcolor: "rgb(231, 67, 182)", float: dir === "rtl" ? "right" : "left", marginLeft: 1, marginRight: 1 }}  > <SquareIcon /> </Avatar>


}




const CategoryMenu = (prop) => {

  const [searchParams, setSearchParams] = useSearchParams();



  const categoryList = prop.data.categoryList



  const categoryId = searchParams.get("CategoryId") || '';


  const handleChange = (event) => {
    const value = event.target.value;
    if (value === '') {

      searchParams.delete("CategoryId")
      setSearchParams(searchParams)


    } else {

      searchParams.set("CategoryId", value)
      setSearchParams(searchParams)


    }
  };



  return (
    <>
      <FormControl sx={{ margin: 1, width: { xs: "96%", sm: "auto" } }}>
        <Select
          value={categoryId}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value={''}>
            <em>{t("NotSpecified")}</em>
          </MenuItem>


          {categoryList.map((data, index) => (

            <MenuItem key={index} value={data.id}>
              <Box sx={{ display: "flex" }}>
                {getAvatar(data, true)}
                <Typography sx={{ marginLeft: 2 }}>{data.name}</Typography>

              </Box>
            </MenuItem>



          ))}
        </Select>
      </FormControl>

    </>
  )




}






function ItemsMobile() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [ItemsList, setItemsList] = useState([]);
  const [pageNumber, setPageNumber] = useState(0)
  const [hasMore, setHasMore] = useState(true);
  const [categoryList, SetCategoryList] = useState([])

  const shopId = searchParams.get("ShopId")
  const categoryId = searchParams.get("CategoryId") || null;
  const itemsListReduser = useSelector((state) => state.getAllItemsSettingReduser);
  const categoryReduser = useSelector((state) => state.getAllCategorySettingReduser);
  const response = itemsListReduser.response;
  const sortBy = "id";
  const sortOrder = "desc"
  const pageSize = 20;
  const [EditRowData, setEditRowData] = useState(null);
  const [deleteItemPrgress, setDeleteItemPrgress] = useState(null);
  const deleteItemSettingReduser = useSelector((state) => state.deleteItemSettingReduser);

  const [dalilogAlretObject, setDalilogAlretObject] = useState({
    open: false,
    msg: "",
    title: "",
    showButtontOne: false,
    buttontOneTitle: "",
    buttonOneFun: () => { },
    showButtontTow: false,
    buttontTowTitle: "",
    buttonTowFun: () => { }
  })




  let { viewSubPage } = useParams();


  /// handel Remove Item From Reduser Item List and Rest delete items slices to defult
  useEffect(() => {
    if (deleteItemSettingReduser.loading === 'succeeded') {


      const newListItems = ItemsList.filter(function (obj) {
        return obj.id !== deleteItemPrgress;
      });



      setItemsList(newListItems)

      dispatch(deleteItems(deleteItemPrgress))
      setDeleteItemPrgress(null)
      dispatch(RestdeleteItemSetting())

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteItemSettingReduser.loading])



  useEffect(() => {

    const pageNumber = 0
    dispatch(reset())
    setHasMore(true);
    setItemsList([]);
    SetCategoryList([])
    setPageNumber(0);
    dispatch(getAllCategorySettingAndItems({ shopId, categoryId, pageNumber, pageSize, sortBy, sortOrder }))
    setItemsList([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, categoryId, viewSubPage])

  useEffect(() => {

    searchParams.delete("CategoryId")
    setSearchParams(searchParams)

    dispatch(getAllCategorySetting({ shopId, categoryId, pageNumber, pageSize, sortBy, sortOrder }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId])



  useEffect(() => {

    if (categoryReduser.loading === "succeeded") {

      dispatch(getAllItemsSetting({ shopId, categoryId, pageNumber, pageSize, sortBy, sortOrder }))
    } else {


    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, dispatch])


  useEffect(() => {

    if (categoryReduser.loading === 'succeeded') {



      SetCategoryList(categoryReduser.response)

    }
  }, [categoryReduser, SetCategoryList])



  const moveNext = () => {
    if (ItemsList.length < response.totalElements) {
      setPageNumber(pageNumber + 1)

    } else {
      setHasMore(false)
    }
  }



  useEffect(() => {


    if (itemsListReduser.loading === 'succeeded') {

      setItemsList([...ItemsList, ...response.content])



    }



    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsListReduser.loading])



  const refresh = () => {
    setHasMore(true);
    setItemsList([]);
    setPageNumber(0);

  }





  if (categoryReduser.loading === "failed") {
    return (<APIErorr reduser={categoryReduser} />)
  }

  if (((categoryReduser.loading === "pending" || categoryReduser.loading === "idle")) || shopId === null) {


    return (<Progress />)
  }


  if (itemsListReduser.loading === "failed") {
    return (<APIErorr reduser={itemsListReduser} />)
  }



  if (viewSubPage === "ItemAddEdit" && categoryList.length > 0) {


    return <AddEditItems item={EditRowData} categoryList={categoryList} />
  }


  const handEditButton = (index) => {

    setEditRowData(ItemsList[index]);


    navigate({

      pathname: "/Dashboard/Settings/Items/ItemAddEdit",
      search: "?" + searchParams.toString()


    })
  }


  const handelAddNewItemButton = () => {
    setEditRowData(null);


    navigate({

      pathname: "/Dashboard/Settings/Items/ItemAddEdit",
      search: "?" + searchParams.toString()


    })
  }

  const handeleDeleteButtonAsync = (index) => async (dispatch) => {
    const itemObject = ItemsList[index]


    setDalilogAlretObject({ ...dalilogAlretObject, "open": false })
    setDeleteItemPrgress(itemObject.id)
    await dispatch(deleteItemSetting({ shopId, itemObject }))
  }


  const handeleDeleteButton = (index) => {


    setDalilogAlretObject({
      ...dalilogAlretObject,
      "open": true,
      "title": t("Delete"),
      "msg": t("MSG1"),
      "showButtontTow": true,
      "buttontTowTitle": t("Yes"),
      "buttonTowFun": () => dispatch(handeleDeleteButtonAsync(index)),
      "showButtontOne": true,
      "buttontOneTitle": t("No"),
      "buttonOneFun": () => setDalilogAlretObject({ ...dalilogAlretObject, "open": false }),
    })




  }


  return (
    <Box >

      <CategoryMenu data={{ categoryList }} />


      <List sx={{ marginTop: 2, height: "100%" }} >

        {ItemsList !== undefined &&
          <InfiniteScroll
            dataLength={ItemsList.length}
            next={moveNext}
            hasMore={hasMore}
            style={{ display: 'flex', flexDirection: "column" }} //To put endMessage and loader to the top.
            loader={ItemsList.length > 0 && <Progress />}
            refreshFunction={refresh}
            pullDownToRefresh
            pullDownToRefreshContent={
              <h3 style={{ textAlign: "center" }}>&# 8595; Pull down to refresh</h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: "center" }}>&# 8593; Release to refresh</h3>
            }
            pullDownToRefreshThreshold={50}

          >

            {ItemsList.map((data, index) => (
              <Box key={index}
                sx={{ marginBottom: 2, marginTop: 1 }}>
                <ListItem
                  className="list-item"

                  secondaryAction={
                    <Box sx={{ display: 'flex', flexDirection: "row", flexFlow: "wrap" }}>
                      <IconButton onClick={() => handEditButton(index)} edge="start" aria-label="edit" sx={{ display: 'flex', flexDirection: "column" }}>
                        <Avatar sx={{ bgcolor: "success.main" }} variant="square" >
                          <EditIcon />

                        </Avatar>
                        <Typography variant='body2'>{t("Edit")}</Typography>
                      </IconButton>

                      <IconButton onClick={() => handeleDeleteButton(index)} edge="end" aria-label="delete" sx={{ display: 'flex', flexDirection: "column" }}>
                        <Avatar sx={{ bgcolor: "error.dark" }} variant="square" >

                          <DeleteIcon />

                        </Avatar>
                        <Typography variant='body2'>{t("Delete")}</Typography>

                      </IconButton>


                    </Box>



                  }


                >
                  <ListItemAvatar>
                    {getAvatar(data, false)}
                  </ListItemAvatar>
                  <ListItemText
                    primary={data.name}

                  />
                </ListItem>

                <ListItem>
                  <Box sx={{ width: "100%" }}>




                    {(deleteItemPrgress === data.id && deleteItemSettingReduser.loading === 'pending') ? <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: "end", alignContent: "end", flexFlow: "wrap" }}>

                      <Progress isScrroling={false} />

                    </Box> : ""}


                    {(deleteItemPrgress === data.id && deleteItemSettingReduser.loading === 'failed') && <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: "end", alignContent: "end", flexFlow: "wrap" }}>

                      <APIErorr isScrroling={false} reduser={deleteItemSettingReduser} />
                    </Box>
                    }

                  </Box>

                </ListItem>
                <Divider />
              </Box>

            ))}

          </InfiniteScroll>}


      </List>



      <Box >


        <Fab onClick={handelAddNewItemButton} sx={{ position: "fixed", bottom: (theme) => theme.spacing(1), right: i18n.dir() !== 'rtl' && 20, }} color="primary" aria-label="add" size='large'>
          <AddIcon />

        </Fab>
      </Box>


      <AlertsDialog controlObject={dalilogAlretObject} setFunc={setDalilogAlretObject} />

    </Box>
  )
}

export default ItemsMobile